/** Keep the breakpoints in sync with the `$breakpoints` map in `static/assets/css/mixins.scss` */
const TABLET_BREAKPOINT = 768;
const PHONE_BREAKPOINT = 480;

const DESKTOP_ITEM_HEIGHT = 120;
const TABLET_ITEM_HEIGHT = 76;
/** phones stack the name, the date and the collection chips, so the row needs ~25% more room */
const PHONE_ITEM_HEIGHT = 95;

/**
 * Calculate the height of a single CatalogView row in the list view mode
 * @param {number} viewportWidth
 * @param {number?} multiplier
 * @returns {number}
 */
export default function getListViewItemHeight(viewportWidth = 0, multiplier = 1) {
  if (viewportWidth >= TABLET_BREAKPOINT) return DESKTOP_ITEM_HEIGHT * multiplier;
  if (viewportWidth >= PHONE_BREAKPOINT) return TABLET_ITEM_HEIGHT * multiplier;

  return PHONE_ITEM_HEIGHT * multiplier;
}
